import type { SessionIssue } from './issue-json';

export const joinPrompt = (lines: string[]) => {
	return lines.join('\n');
};

export const generatePrompt = (input: { issue?: SessionIssue; userPrompt?: string }) => {
	if (input.issue) {
		return joinPrompt([
			'Please generate code to help me solve the following Jira issue:',
			'',
			`Summary: ${input.issue.summary}`,
			`Description: ${input.issue.description}`,
		]);
	}

	return '';
};
